import { useState, useEffect, createContext, useContext } from 'react';
import api from '@/lib/api';

const TimezoneContext = createContext('America/New_York');

export const useTimezone = () => useContext(TimezoneContext);

export const TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'Eastern (ET)' },
  { value: 'America/Chicago', label: 'Central (CT)' },
  { value: 'America/Denver', label: 'Mountain (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific (PT)' },
  { value: 'America/Anchorage', label: 'Alaska (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (HT)' },
  { value: 'America/Phoenix', label: 'Arizona (no DST)' },
  { value: 'UTC', label: 'UTC' },
];

export const TimezoneProvider = ({ children }) => {
  const [tz, setTz] = useState(() => {
    const stored = localStorage.getItem('vs_timezone');
    return stored || 'America/New_York';
  });

  useEffect(() => {
    const token = localStorage.getItem('vs_token');
    if (!token) return; // Don't call API for unauthenticated visitors
    api.get('/settings/notifications').then(r => {
      const serverTz = r.data?.timezone;
      if (serverTz) {
        setTz(serverTz);
        localStorage.setItem('vs_timezone', serverTz);
      }
    }).catch(() => {});
  }, []);

  return <TimezoneContext.Provider value={tz}>{children}</TimezoneContext.Provider>;
};

function ensureUtc(dateStr) {
  if (!dateStr) return '';
  const s = String(dateStr);
  // If no timezone indicator, append Z (UTC)
  if (!s.endsWith('Z') && !s.includes('+') && !s.includes('-', 10)) {
    return s + 'Z';
  }
  return s;
}

export function formatDate(dateStr, tz) {
  if (!dateStr) return '';
  try {
    const date = new Date(ensureUtc(dateStr));
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      timeZone: tz || 'America/New_York',
      month: 'short', day: 'numeric', year: 'numeric',
    });
  } catch { return String(dateStr).slice(0, 10); }
}

export function formatDateTime(dateStr, tz) {
  if (!dateStr) return '';
  try {
    const date = new Date(ensureUtc(dateStr));
    if (isNaN(date.getTime())) return '';
    return date.toLocaleString('en-US', {
      timeZone: tz || 'America/New_York',
      month: 'short', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit', hour12: true,
    });
  } catch { return String(dateStr).slice(0, 19); }
}
